// API service for appointment reports
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

class AppointmentReportsService {
  // Get daily appointment report for a specific month
  static async getDailyAppointmentReport(token, year, month, locationId = 'all', doctorId = 'all') {
    try {
      const params = new URLSearchParams({ year, month });
      if (locationId && locationId !== 'all') params.append('locationId', locationId);
      if (doctorId && doctorId !== 'all') params.append('doctorId', doctorId);
      const response = await fetch(`${API_BASE_URL}/reports/appointments/daily?${params.toString()}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data.data;
    } catch (error) {
      console.error('Error fetching daily appointment report:', error);
      throw error;
    }
  }

  // Get monthly appointment report for a specific year
  static async getMonthlyAppointmentReport(token, year, locationId = 'all', doctorId = 'all') {
    try {
      const params = new URLSearchParams({ year });
      if (locationId && locationId !== 'all') params.append('locationId', locationId);
      if (doctorId && doctorId !== 'all') params.append('doctorId', doctorId);
      const response = await fetch(`${API_BASE_URL}/reports/appointments/monthly?${params.toString()}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data.data;
    } catch (error) {
      console.error('Error fetching monthly appointment report:', error);
      throw error;
    }
  }

  // Get yearly appointment report
  static async getYearlyAppointmentReport(token, startYear = null, endYear = null) {
    try {
      let url = `${API_BASE_URL}/reports/appointments/yearly`;
      const params = new URLSearchParams();
      
      if (startYear) params.append('startYear', startYear);
      if (endYear) params.append('endYear', endYear);
      
      if (params.toString()) {
        url += `?${params.toString()}`;
      }

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data.data;
    } catch (error) {
      console.error('Error fetching yearly appointment report:', error);
      throw error;
    }
  }
}

export default AppointmentReportsService;
